import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Link from '@material-ui/core/Link'
import Logo from 'assets/images/dokify-logo-small-grey.svg'
import useStyles from './styles'
import useTranslation from 'hooks/useTranslations'
import { IntlContext } from 'context/LocaleContext'

const Footer = () => {
  const t = useTranslation()
  const { locale, changeLocale } = useContext(IntlContext)

  const languages = [
    {
      value: 'es',
      label: t('footer:select:es'),
    },
    {
      value: 'en',
      label: t('footer:select:en'),
    },
    {
      value: 'de',
      label: t('footer:select:de'),
    },
    {
      value: 'it',
      label: t('footer:select:it'),
    },
    {
      value: 'fr',
      label: t('footer:select:fr'),
    },
    {
      value: 'pt',
      label: t('footer:select:pt'),
    },
    {
      value: 'ca',
      label: t('footer:select:ca'),
    },
  ]

  const classes = useStyles()
  const handleChange = event => {
    changeLocale(event.target.value)
  }

  return (
    <Box component="footer" className={classes.root}>
      <form noValidate autoComplete="off" className={classes.form}>
        <TextField
          className={classes.select}
          fullWidth
          id="standard-select-language"
          select
          label={t('footer:language')}
          value={locale}
          onChange={handleChange}
        >
          {languages.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </form>
      <img className={classes.logo} src={Logo} alt="Dockify Logo" />
      <Box className={classes.links}>
        <Link
          href={t('footer:url-terms-of-service')}
          target="_blank"
          rel="noopener noreferrer"
          variant="body2"
        >
          {t('footer:terms-of-service')}
        </Link>
        <Link
          href={t('footer:url-policy')}
          target="_blank"
          rel="noopener noreferrer"
          variant="body2"
          className={classes.link}
        >
          {t('footer:policy')}
        </Link>
        <Link
          href={t('footer:url-legal')}
          target="_blank"
          rel="noopener noreferrer"
          variant="body2"
          className={classes.link}
        >
          {t('footer:legal')}
        </Link>
      </Box>
    </Box>
  )
}

export default Footer
